(ns storrito.util
  (:require [vire.adserver.view.colors :as c]
            [goog.labs.userAgent.browser :as browser]
            [reagent.crypt :as crypt]
            [storrito.date.format :as date-format]
            [cljs-time.core :as t]
            [cljs.reader :as reader]
            [storrito.ui.button :as button])
  (:import [goog.format EmailAddress]
           goog.net.jsloader))

(defn is-safari? []
  (browser/isSafari))

(defn is-mobile? []
  "Mobile definition by Bulma :
  https://bulma.io/documentation/helpers/visibility-helpers/"
  (<= js/window.screen.width 768))

(def web-codecs?
  (try
    (js/ImageDecoder. (clj->js {:data (js/ReadableStream.), :type "image/gif"}))
    true
    (catch js/ReferenceError e false)))

(defn browser-message [state]
  (when
    (and
          (or (browser/isEdge)
              (browser/isIE)
              (browser/isSafari))
          (not (:app/browser-message-hidden @state)))
    [:div.bg-yellow-50.border-l-4.border-yellow-400.p-4.fixed.vire-center-fixed.cursor-pointer
     {:style {:z-index 100}
      :onClick (fn [e]
                 (.preventDefault e)
                 (swap! state assoc
                        :app/browser-message-hidden true))}
     [:div.flex
      [:div.flex-shrink-0
       [:svg.h-5.w-5.text-yellow-400 {:xmlns "http://www.w3.org/2000/svg" :viewBox "0 0 20 20" :fill "currentColor" :aria-hidden "true"}
        [:path {:fill-rule "evenodd" :d "M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" :clip-rule "evenodd"}]]]
      [:div.ml-3
       [:p.text-sm.text-yellow-700 "Storrito only works best on "
        [:span.font-medium.underline.text-yellow-700.hover:text-yellow-600 "Chrome, Firefox and Opera."]]]]]))

(defn set-item!
  "Set `key' in browser's localStorage to `val`."
  [key val]
  (try
    (.setItem js/window.localStorage (name key) (prn-str val))
    (catch :default e
      (js/console.error "Failed to write to localStorage" e)
      nil)))

(defn get-item
    "Returns value of `key' from browser's localStorage."
    [key]
    (try
      (-> (.getItem js/window.localStorage
                    (name key))
          (reader/read-string))
      (catch :default e
        (js/console.error "Failed to read from localStorage" e)
        nil)))

(defn remove-item!
  "Returns value of `key' from browser's localStorage."
  [key]
  (try
    (.removeItem js/window.localStorage (name key))
    (catch :default e
      (js/console.error "Failed to remove from localStorage" e)
      nil)))

(defn cookies-message
  [state]
  (when (and (not (:app/cookies-message-hidden @state))
             (not (get-item :cookies-message-hidden)))
    [:div {:class "bg-white rounded-md text-gray-700 block p-5 shadow-lg"
           :style {:display "flex"
                       :align-items "center"
                       :align-self "center"
                       :padding "15px"
                       :background-color c/background-color-transparent}}
     [:div
      "We are using cookies. "
      [:a {:href "http://storrito.com/cookies/"} " Learn more."]]
     [button/icon-cancel {:class "ml-2"
                          :onClick (fn [e]
                                     (.preventDefault e)
                                     (set-item! :cookies-message-hidden true)
                                     (swap! state assoc
                                            :app/cookies-message-hidden true))}]]))

(defn clamp [value minimum maximum]
  (min maximum (max minimum value)))

(defn parse-int
  "Thank you Javascript!"
  [str]
  (let [value (js/parseInt str 10)]
    (when-not (js/isNaN value)
      value)))

(defn md5
  [s]
  (crypt/hash s :md5 true))

(defn begin-of-next-month
  "Returns the begin of the next month as DateTime."
  []
  (date-format/begin-of-month
    (t/plus (t/now)
            (t/months 1))))
